import { render, staticRenderFns } from "./adPageDecoration.vue?vue&type=template&id=6aa3bc25&"
import script from "./adPageDecoration.vue?vue&type=script&lang=js&"
export * from "./adPageDecoration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports